<template>
  <div>
    <v-row>
      <v-col xl="6" lg="6" md="6" sm="12">
        <config-api
          :integrationData="integrationData"
          :integrationsList="integrationsList"
          @openIntegrationDataDialog="openIntegrationDataDialog($event)"
          @verifyIntegrationStatus="verifyIntegrationStatus($event)"
          @getIntegrations="getIntegrations(integrationName)"
          @runIntegration="runIntegration"
        />
        <integration-data-dialog
          v-if="showIntegrationDataDialog"
          :showDialog="showIntegrationDataDialog"
          :objectData="dialogs.objectIntegration"
          @goBack="closeIntegrationDataDialog('goBack')"
          @submitForm="closeIntegrationDataDialog('submitForm')"
        />
      </v-col>
      <v-col xl="6" lg="6" md="6" sm="12">
        <div class="d-flex-inline flex-wrap">
          <v-card dark>
            <v-card-title class="d-flex justify-space-between">
              <div>
                <span>Tabelas {{ integrationName }}</span>
              </div>
              <div>
                <v-icon>mdi-table</v-icon>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="d-flex flex-wrap">
                <div v-for="button in tablesButtons" :key="button.name">
                  <v-btn
                    v-if="button.released"
                    :color="button.selected ? `green darken-4` : `green`"
                    class="mx-1 my-1"
                    @click="selectTable(button)"
                    :disabled="!integrationStatus"
                  >
                    <span class="text-caption">{{ button.name }}</span>
                  </v-btn>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <div class="d-flex flex-wrap" v-if="selectedTable != ''">
                <div v-for="action in selectedTableActions" :key="action.value">
                  <v-btn
                    v-if="action.released"
                    :color="action.selected ? 'cyan darken-4' : 'cyan darken-1'"
                    class="mx-1 my-1"
                    @click="selectTableActions(action)"
                  >
                    <span class="text-caption">{{ action.name }}</span>
                  </v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="selectedTable != '' && dataHeader.length > 0">
      <v-col cols="12">
        <filters
          :tableActive="selectedTable"
          :filters="filters"
          @filter="performFilters($event)"
        />
      </v-col>
    </v-row>
    <v-row v-if="!dialogs.showOrderDataDialog">
      <v-col>
        <!-- Tabela  -->
        <v-data-table
          dark
          :items="dataList"
          :headers="dataHeader"
          :search="search"
          :custom-filter="filterOnTable"
        >
          <template v-slot:top>
            <v-toolbar flat v-if="selectedAction">
              <v-toolbar-title
                v-if="selectedAction.value.indexOf('inserir') != -1"
              >
                Integrar {{ selectedTable }}
              </v-toolbar-title>
              <v-toolbar-title v-else>{{ selectedTable }} </v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>

              <v-text-field
                v-model="search"
                class="mt-6"
                :label="$t('tabelas.filtrar')"
                dense
                prepend-inner-icon="mdi-magnify"
                single-line
                hide-details
                clearable
              ></v-text-field>

              <v-spacer></v-spacer>
              <v-btn
                v-if="
                  selectedAction && selectedAction.value == 'categorias.inserir'
                "
                color="info accent-3"
                class="mx-1"
                @click="sendCategories"
              >
                <span class="text-caption">{{ $t('labels.enviar') }}</span>
                <v-icon small right>mdi-upload</v-icon>
              </v-btn>
              <v-btn
                v-else-if="
                  selectedAction &&
                  selectedAction.value == 'fabricantes.inserir'
                "
                color="info accent-3"
                class="mx-1"
                @click="sendManufacturers"
              >
                <span class="text-caption">Enviar</span>
                <v-icon small right>mdi-upload</v-icon>
              </v-btn>
              <v-btn
                v-else-if="
                  selectedAction && selectedAction.value == 'produtos.inserir'
                "
                color="info accent-3"
                class="mx-1"
                @click="sendProducts"
              >
                <span class="text-caption">Enviar</span>
                <v-icon small right>mdi-upload</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.IDITEMINTEGRACAO="{ item }">
            <v-chip
              v-if="
                item.IDITEMINTEGRACAO && parseInt(item.IDITEMINTEGRACAO) > 0
              "
              small
              color="success"
              >{{ item.IDITEMINTEGRACAO }}</v-chip
            >
          </template>
          <template v-slot:item.IDINTEGRACAO="{ item }">
            <v-chip
              v-if="item.IDINTEGRACAO && parseInt(item.IDINTEGRACAO) > 0"
              small
              color="success"
              >{{ item.IDINTEGRACAO }}</v-chip
            >
          </template>
          <template v-slot:item.CATEGORIAS="{ item }">
            <v-btn
              color="blue accent-4"
              x-small
              @click="showCategories(item.CATEGORIAS)"
              disabled
            >
              <span class="text-caption">ver categorias</span>
            </v-btn>
          </template>
          <template v-slot:item.images="{ item }">
            <v-tooltip top v-if="item.images">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="toogleOverlay(item)"
                  x-small
                >
                  <v-icon color="blue">mdi-image-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('tabelas.verImagem') }}</span>
            </v-tooltip>
            <div v-else>
              <span class="red--text">X</span>
            </div>
          </template>
          <template v-slot:item.SALDOITEM="{ item }">
            <span>
              {{
                item.SALDOITEM - parseInt(item.SALDOITEM, 10) > 0
                  ? formatDecimal(item.SALDOITEM, 4, 2)
                  : formatDecimal(item.SALDOITEM, 0, 0)
              }}
            </span>
          </template>
          <template v-slot:item.PRECO="{ item }">
            <span>
              {{ formatCurrency(0, item.PRECO) }}
            </span>
          </template>
          <template v-slot:item.PRECOVAREJO="{ item }">
            <span>
              {{ formatCurrency(0, item.PRECOVAREJO) }}
            </span>
          </template>
          <template v-slot:item.PESO="{ item }">
            <v-tooltip top v-if="parseFloat(item.PESO) <= 0">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-on="on"
                  v-bind="attrs"
                  color="orange"
                  text-color="white"
                  small
                >
                  {{
                    integrationData.CONVERTEPESOGRAMAS
                      ? formatDecimal(item.PESO, 0, 0)
                      : formatDecimal(item.PESO, 4, 2)
                  }}
                  <v-icon small right>mdi-alert-outline</v-icon>
                </v-chip>
              </template>
              <span class="text-caption">Conferir peso produto</span>
            </v-tooltip>
            <div v-else>
              <span>
                {{
                  integrationData.CONVERTEPESOGRAMAS
                    ? formatDecimal(item.PESO, 0, 0)
                    : formatDecimal(item.PESO, 4, 2)
                }}
              </span>
            </div>
          </template>
          <template v-slot:item.editarProdutosIntegracao="{ item }">
            <v-btn-toggle tile>
              <v-btn
                class="mr-1 rounded"
                fab
                x-small
                color="yellow darken-2"
                @click="editIntegrationProducts(item)"
              >
                <v-icon dark>mdi-pen</v-icon>
              </v-btn>
              <v-btn
                class="rounded"
                fab
                x-small
                color="red accent-4"
                @click="removeItemIntegrationList(item, 'CODIGO')"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <template v-slot:item.editProduct="{ item }">
            <v-btn-toggle>
              <v-btn
                @click="editItemTable(item, 'Product')"
                color="warning darken-1"
                x-small
              >
                <span class="text-caption">editar</span>
                <v-icon small right>mdi-pen</v-icon>
              </v-btn>
              <v-btn
                @click="removeIntegrationTable(item, 'Product', 'CODIGO')"
                class="rounded"
                color="red accent-4"
                x-small
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <template v-slot:item.editCategory="{ item }">
            <v-btn-toggle>
              <v-btn
                @click="editItemTable(item, 'Category')"
                color="warning darken-1"
                x-small
              >
                <span class="text-caption">editar</span>
                <v-icon small right>mdi-pen</v-icon>
              </v-btn>
              <v-btn
                @click="removeIntegrationTable(item, 'Category')"
                class="rounded"
                color="red accent-4"
                x-small
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <template v-slot:item.editarCategoriasIntegracao="{ item }">
            <v-btn-toggle tile>
              <v-btn
                class="mr-1 rounded"
                fab
                x-small
                color="yellow darken-2"
                @click="editIntegrationCategories(item)"
              >
                <v-icon dark>mdi-pen</v-icon>
              </v-btn>
              <v-btn
                class="rounded"
                fab
                x-small
                color="red accent-4"
                @click="removeItemIntegrationList(item, 'ID')"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <template v-slot:item.editManufacturer="{ item }">
            <v-btn-toggle>
              <v-btn
                @click="editItemTable(item, 'Manufacturer')"
                color="warning darken-1"
                x-small
              >
                <span class="text-caption">editar</span>
                <v-icon small right>mdi-pen</v-icon>
              </v-btn>
              <v-btn
                @click="
                  removeIntegrationTable(item, 'Manufacturer', 'FABRICANTE')
                "
                class="rounded"
                color="red accent-4"
                x-small
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <template v-slot:item.editarFabricantesIntegracao="{ item }">
            <v-btn-toggle tile>
              <v-btn
                class="rounded"
                fab
                x-small
                color="red accent-4"
                @click="removeItemIntegrationList(item, 'NOME')"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
          <template
            v-if="selectedAction && selectedAction.value == 'produtos.inserir'"
            v-slot:item.CATEGORIES="{ item }"
          >
            <span v-for="category in item.CATEGORIES" :key="category.CODIGO"
              >{{ category.CODIGO }},</span
            >
          </template>
          <template
            v-if="selectedAction && selectedAction.value == 'produtos.inserir'"
            v-slot:item.FABRICANTE_INTEGRACAO="{ item }"
          >
            <span>
              {{
                `${
                  item.FABRICANTE_INTEGRACAO
                    ? `${item.FABRICANTE_INTEGRACAO.CODIGO} - ${item.FABRICANTE_INTEGRACAO.NOME}`
                    : `${item.FABRICANTE_INTEGRACAO}`
                }`
              }}
            </span>
          </template>
          <template
            v-if="selectedAction && selectedAction.value == 'categorias.lista'"
            v-slot:item.img="{ item }"
          >
            <v-btn
              v-if="item.img"
              x-small
              color="blue accent-2"
              target="_blank"
              :href="item.img"
            >
              <v-icon small>mdi-image</v-icon>
            </v-btn>
            <v-btn v-else x-small color="red accent-2">
              <v-icon small>mdi-image-off</v-icon>
            </v-btn>
          </template>
          <template
            v-if="selectedAction && selectedAction.value == 'categorias.lista'"
            v-slot:item.img_h="{ item }"
          >
            <v-btn
              v-if="item.img_h"
              x-small
              color="blue accent-2"
              target="_blank"
              :href="item.img_h"
            >
              <v-icon small>mdi-image</v-icon>
            </v-btn>
            <v-btn v-else x-small color="red accent-2">
              <v-icon small>mdi-image-off</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-row>
          <v-col cols="12" class="d-inline-flex">
            <!-- <v-pagination
              class="ml-auto"
              v-model="query.page"
              :total-visible="pagination.per_page"
              :length="pagination.last_page"
              :disabled="loadingItems"
              @input="sendSearch()"
            /> -->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row dense>
      <v-dialog v-model="dialogs.showExportProductDialog" width="500">
        <export-file
          :columnList="integrationData.COLUNAS_EXPORTACAO"
          :filters="filters.product"
          @openBindColumn="dialogBindColumns = !dialogBindColumns"
          @close="closeExportDialog()"
        />
      </v-dialog>
      <v-dialog v-model="dialogBindColumns" width="600">
        <bind-column-item
          :integrationColumns="integrationData.COLUNAS_EXPORTACAO"
          @bindSettings="setBindedColumnsList($event)"
          @close="dialogBindColumns = false"
        />
      </v-dialog>
      <v-dialog v-model="dialogs.showDialogAssociateProducts" width="600">
        <products-association
          @associateProducts="associateProductsIntegration($event)"
          @close="dialogs.showDialogAssociateProducts = false"
        />
      </v-dialog>
      <v-col v-if="dialogs.showOrderDataDialog" cols="12">
        <import-file
          @prepareToSend="prepareToSend"
          @changeFile="changeFileOrder"
          @validate="validateOrders"
          :statusList="statusList"
          :orderSpecs="orderSpecs"
          :integration="integrationData"
          :hasOrders="orderList.length > 0"
        />
      </v-col>
    </v-row>
    <v-row v-if="integrationType === 'Pedidos' && orderData.length > 0">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-data-table
          :headers="orderHeader"
          :items="orderList"
          dark
          dense
          :item-class="estilizaLinha"
          show-expand
          item-key="pedido"
          :calculate-widths="true"
        >
          <template
            v-for="(ordHeader, index) in orderHeader"
            v-slot:[`item.${ordHeader.value}`]="{ item }"
          >
            <div v-if="ordHeader.value == 'warnings'" :key="index">
              <v-btn
                fab
                small
                text
                :color="item.warnings.length > 0 ? 'orange' : 'green'"
                @click="showWarnings(item.warnings)"
              >
                <v-icon
                  >mdi-{{
                    item.warnings.length > 0 ? 'alert-octagon' : 'check-bold'
                  }}</v-icon
                >
              </v-btn>
            </div>
            <div
              v-else-if="currencyFields.lastIndexOf(ordHeader.value) != -1"
              :key="index"
            >
              <td>
                {{ formatCurrency(0, item[ordHeader.value]) }}
              </td>
            </div>
            <div v-else :key="index">
              <td>
                {{ item[ordHeader.value] }}
              </td>
            </div>
          </template>
          <template #expanded-item="{ headers, item }">
            <td
              :colspan="itemHeader.length || headers.length"
              class="pa-1 accent text-no-wrap"
            >
              <v-data-table
                :headers="itemHeader"
                :items="item.items"
                dark
                dense
                :item-class="estilizaLinha"
              >
                <template
                  v-for="(header, index) in itemHeader"
                  v-slot:[`item.${header.value}`]="{ item }"
                >
                  <div v-if="header.value == 'warnings'" :key="index">
                    <v-btn
                      fab
                      small
                      text
                      :color="item.warnings.length > 0 ? 'orange' : 'green'"
                      @click="showWarnings(item.warnings)"
                    >
                      <v-icon
                        >mdi-{{
                          item.warnings.length > 0
                            ? 'alert-octagon'
                            : 'check-bold'
                        }}</v-icon
                      >
                    </v-btn>
                  </div>

                  <div
                    v-else-if="currencyFields.lastIndexOf(header.value) != -1"
                    :key="index"
                  >
                    <td>
                      {{ formatCurrency(0, item[header.value]) }}
                    </td>
                  </div>
                  <div v-else :key="index">
                    <td>
                      {{ item[header.value] }}
                    </td>
                  </div>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <template>
        <overlay-item
          :isVisible="overlay.overlay"
          :isAbsolute="overlay.absolute"
          :imagesList="imagesList"
          :item="overlay.item"
          :especificacoes="overlay.especificacoes"
          :opacity="0.8"
          v-model="overlay.model"
          v-if="overlay.overlay"
          @closeOverlay="closeOverlay"
        />
        <select-category
          v-if="dialogs.showSelectCategory"
          @goBack="dialogs.showSelectCategory = false"
          :showDialog="dialogs.showSelectCategory"
          @addItens="showSelectedCategories($event)"
        />
        <select-manufacturer
          v-if="dialogs.showSelectManufacturer"
          @goBack="dialogs.showSelectManufacturer = false"
          :showDialog="dialogs.showSelectManufacturer"
          @addItens="showSelectedManufacturers($event)"
        />
        <select-brand
          v-if="dialogs.showSelectBrand"
          @goBack="dialogs.showSelectBrand = false"
          :showDialog="dialogs.showSelectBrand"
          @addItens="showSelectedManufacturers($event)"
        />
        <category-dialog
          v-if="dialogs.showCategoryDialog"
          :showDialog="dialogs.showCategoryDialog"
          @goBack="dialogs.showCategoryDialog = false"
          :objectData="dialogs.categoryObject"
        />
        <message-dialog
          :showDialog="dialogs.showMessageDialog"
          :message="dialogs.messageArray"
          :width="700"
          scrollable
          @close="dialogs.showMessageDialog = false"
        />
        <select-basic
          v-if="dialogs.showSelectBasic"
          :showDialog="dialogs.showSelectBasic"
          :componentOwner="integrationName"
          @close="dialogs.showSelectBasic = false"
          @addItens="showSelectedProducts($event)"
          :integration="integrationData"
        />
        <confirm-dialog-errors
          ref="confirmDialogErrors"
          v-model="confirmDialogErrors"
        />
        <integration-item
          v-if="dialogs.showIntegrationProductDialog"
          @goBack="dialogs.showIntegrationProductDialog = false"
          :submitForm="editIntegrationProducts"
          :showDialog="dialogs.showIntegrationProductDialog"
          :objectData="dialogs.objectProduct"
          :integration="integrationData"
        />
        <integration-item
          v-if="dialogs.showIntegrationEditProductDialog"
          @goBack="dialogs.showIntegrationEditProductDialog = false"
          :submitForm="sendProduct"
          :showDialog="dialogs.showIntegrationEditProductDialog"
          :objectData="dialogs.objectProduct"
          :integration="integrationData"
        />
        <integration-category
          v-if="dialogs.showIntegrationCategoryDialog"
          @goBack="dialogs.showIntegrationCategoryDialog = false"
          :submitForm="editIntegrationCategories"
          :showDialog="dialogs.showIntegrationCategoryDialog"
          :objectData="dialogs.objectCategory"
        />
        <integration-category
          v-if="dialogs.showIntegrationEditCategoryDialog"
          :isEdit="true"
          @goBack="dialogs.showIntegrationEditCategoryDialog = false"
          :submitForm="sendCategory"
          :showDialog="dialogs.showIntegrationEditCategoryDialog"
          :objectData="dialogs.objectCategory"
        />
        <integration-manufacturer
          v-if="dialogs.showIntegrationManufacturerDialog"
          @goBack="dialogs.showIntegrationManufacturerDialog = false"
          :submitForm="editIntegrationManufacturer"
          :showDialog="dialogs.showIntegrationManufacturerDialog"
          :objectData="dialogs.objectManufacturer"
        />
        <integration-manufacturer
          v-if="dialogs.showIntegrationEditManufacturerDialog"
          :isEdit="true"
          @goBack="dialogs.showIntegrationEditManufacturerDialog = false"
          :submitForm="sendManufacturer"
          :showDialog="dialogs.showIntegrationEditManufacturerDialog"
          :objectData="dialogs.objectManufacturer"
        />
      </template>
    </v-row>
    <confirm ref="confirm" v-model="confirm"></confirm>
  </div>
</template>

<script>
import service from '@/services/integration/IntegrationService'
import trayService from '@/services/integration/tray/TrayService'

import XLSX from 'xlsx'
import { mapActions, mapGetters } from 'vuex'
import {
  verifyOrderWarnings,
  convertOrdersList,
  convertOrdersHeader,
  prepareOrderObject,
  convertItemsList,
  convertItemsHeader,
} from '@/utils/integrationUtils'
import { converterDataDB } from '@/utils/utils'
import { integrationMixin } from '@/mixins/object/integration/IntegrationMixin'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'

export default {
  mixins: [currencyMixin, integrationMixin],
  components: {
    overlayItem: () => import('@/components/shared/base-overlay/BaseOverlay'),
    Confirm: () => import('@/components/shared/base-dialog/Confirm.vue'),
    ConfirmDialogErrors: () =>
      import('@/components/unique/pdv-balcao/ConfirmPendingBills'),
    IntegrationItem: () =>
      import('@/components/unique/integration/tray/IntegrationItem'),
    IntegrationCategory: () =>
      import('@/components/unique/integration/tray/IntegrationCategory.vue'),
    IntegrationManufacturer: () =>
      import(
        '@/components/unique/integration/tray/IntegrationManufacturer.vue'
      ),
    SelectBasic: () => import('@/components/object/item/SelectBasic'),
    SelectCategory: () => import('@/components/object/category/Select'),
    SelectBrand: () => import('@/components/object/brand/Select'),
    SelectManufacturer: () => import('@/components/object/manufacturer/Select'),
    Filters: () => import('@/components/unique/integration/tray/Filters'),
    MessageDialog: () =>
      import('@/components/shared/base-dialog/MessageDialog'),
    ImportFile: () => import('@/components/unique/integration/tray/Import'),
    ExportFile: () => import('@/components/unique/integration/tray/Export'),
    BindColumnItem: () =>
      import('@/components/unique/integration/tray/BindColumnItem'),

    ProductsAssociation: () =>
      import('@/components/unique/integration/tray/ProductsAssociation'),

    ConfigApi: () => import('@/components/unique/integration/ConfigApi.vue'),
    IntegrationDataDialog: () =>
      import('@/components/unique/integration/IntegrationData'),
  },
  computed: {
    ...mapGetters({
      authUser: 'authModule/getAuthUser',
      system: 'systemModule/getCurrentSystem',
      freshIntegration: 'trayModule/getIntegration',
      productIntegrationList: 'trayModule/getProducts',
      categoryIntegrationList: 'trayModule/getCategories',
      manufacturerIntegrationList: 'trayModule/getManufacturers',
      orderIntegrationList: 'trayModule/getOrders',
      integrateErrors: 'trayModule/getIntegrateErrors',
      integrateInfos: 'trayModule/getIntegrateInfos',
    }),
    excludedHeaders() {
      return ['IMAGEM', 'IMAGEM1', 'IMAGEM2', 'IMAGEM3']
    },
    categoryHeaders() {
      return [
        {
          text: 'Código',
          value: 'ID',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Descrição',
          value: 'NOME',
          class: 'backgroundColor: light-blue darken-4',
        },
        // {
        //   text: 'Subtitulo',
        //   value: 'SUBTITULO',
        //   class: 'backgroundColor: light-blue darken-4',
        // },
        {
          text: 'Categoria Pai',
          value: 'PARENT_ID',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'ID Integração',
          value: 'IDINTEGRACAO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'ID Integração Pai',
          value: 'PARENT_IDINTEGRACAO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Ações',
          value: 'editCategory',
          class: 'backgroundColor: light-blue darken-4',
          width: '100',
        },
      ]
    },
    categoryHeadersToIntegrate() {
      return [
        {
          text: 'Código',
          value: 'ID',
          class: 'backgroundColor: light-blue darken-4',
          width: '100',
        },
        {
          text: 'Descrição',
          value: 'NOME',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Categoria Pai',
          value: 'PARENT_ID',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'ID Integração',
          value: 'IDINTEGRACAO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Ações',
          value: 'editarCategoriasIntegracao',
          class: 'backgroundColor: light-blue darken-4',
          width: '100',
        },
      ]
    },
    manufacturerHeaders() {
      return [
        {
          text: 'Fabricante',
          value: 'FABRICANTE',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'ID Integração',
          value: 'IDINTEGRACAO',
          class: 'backgroundColor: light-blue darken-4',
          width: '100',
        },
        {
          text: 'Ações',
          value: 'editManufacturer',
          class: 'backgroundColor: light-blue darken-4',
          width: '100',
        },
      ]
    },
    manufacturerHeadersToIntegrate() {
      return [
        {
          text: 'Código',
          value: 'CODIGO',
          class: 'backgroundColor: light-blue darken-4',
          width: '100',
        },
        {
          text: 'ID Integração',
          value: 'IDINTEGRACAO',
          class: 'backgroundColor: light-blue darken-4',
          width: '100',
        },
        {
          text: 'Descrição',
          value: 'NOME',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Ações',
          value: 'editarFabricantesIntegracao',
          width: '100',
          class: 'backgroundColor: light-blue darken-4',
        },
      ]
    },
    productHeaders() {
      return [
        {
          text: 'Código',
          value: 'CODIGO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'ID Integração',
          value: 'IDITEMINTEGRACAO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Descrição',
          value: 'DESCRICAO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Preço',
          value: 'PRECO',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Saldo',
          value: 'SALDOITEM',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: `Peso ${
            this.integrationData.CONVERTEPESOGRAMAS ? 'Gramas' : 'Kg'
          }`,
          value: 'PESO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Medidas [AxLxP]',
          value: 'MEDIDA',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Preço Sob Consulta',
          value: 'ISPERMITIRCOMPRA',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Ativo',
          value: 'VENDAINTERNET',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Imagens',
          value: 'images',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Ações',
          value: 'editProduct',
          class: 'backgroundColor: light-blue darken-4',
        },
        // { text: 'Integração', value: 'INTEGRACAO' },
      ]
    },
    productHeadersToIntegrate() {
      return [
        {
          text: 'Código',
          value: 'CODIGO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'ID Integração',
          value: 'IDITEMINTEGRACAO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Descrição',
          value: 'DESCRICAO',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Preço Integração',
          value: 'PRECO',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Preço Tabela',
          value: 'PRECOVAREJO',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Ativo',
          value: 'VENDAINTERNET',
          align: 'center',
          class: 'backgroundColor: light-blue darken-4',
        },
        {
          text: 'Ações',
          value: 'editarProdutosIntegracao',
          class: 'backgroundColor: light-blue darken-4',
        },
      ]
    },
    widthOverlay() {
      const size = {
        default: {
          xs: '600',
          sm: '600',
          md: '900',
          lg: '900',
          xl: '1200',
        },
      }
      let breakpointName = this.$vuetify.breakpoint.name
      return size.default[breakpointName] ?? 600
    },
    orderSpecs() {
      const warnings = this.orderList.filter(
        (order) => order.warnings.length > 0
      ).length
      const valid = this.orderList.filter(
        (order) => order.warnings.length <= 0
      ).length
      const orders = this.orderList.length
      const items = this.itemData.length

      return { orders, valid, warnings, items }
    },
    orderList() {
      let warningOrders =
        this.orderData.filter((row) => row.warnings.length > 0) || []
      let correctOrders =
        this.orderData.filter((row) => row.warnings.length <= 0) || []
      return [...warningOrders, ...correctOrders]
    },
    itemOrderList() {
      return this.itemData
    },
    integrationStatus() {
      return this.integrationData.ATIVO && this.integrationData.ATIVO == 'S'
    },
  },
  data: () => {
    return {
      query: {
        codigo: 0,
        descricao: '',
        uf: '',
        codigoMunicipio: '',
        page: 1,
        todos: null,
      },
      currencyFields:
        ',preco,custo,subtotalDeProdutos,valorPgto,valorFrete,pagamento1,valorComissao,desconto,acrescimoForma,cartoes,',
      item: {},
      confirm: false,
      confirmDialogErrors: false,
      filters: {
        product: {
          description: '',
          category: '',
          manufacturer: '',
          quantity: '',
          operatorQuantityIndex: '',
          operatorWeight: '',
          integrados: '',
          vendaInternet: false,
        },
        order: {
          dataini: '',
          datafim: '',
          numero: '',
        },
      },
      imagesList: [],
      statusList: [],
      dataList: [],
      dataHeader: [],
      selectedTable: '',
      selectedTableActions: [],
      selectedAction: null,
      tablesButtons: [
        //Botao Categorias
        {
          name: 'Categorias',
          selected: false,
          released: false, // aguardar testes tray
          actions: [
            {
              name: 'Lista',
              value: 'categorias.lista',
              released: true,
              selected: false,
            },
            {
              name: 'Lista [ID]',
              value: 'categorias.lista.id',
              released: false,
              selected: false,
            },
            {
              name: 'Detalhes [ID]',
              value: 'categorias.detalhes.id',
              released: false,
              selected: false,
            },
            {
              name: 'Inserir',
              value: 'categorias.inserir',
              released: true,
              selected: false,
            },
            {
              name: 'Forçar Sincronismo',
              value: 'categorias.forcar.sincronismo',
              released: false,
              selected: false,
            },
          ],
        },
        //Botao Fabricantes
        {
          selected: false,
          name: 'Fabricantes',
          released: false, // aguardar testes tray
          actions: [
            {
              name: 'Lista',
              value: 'fabricantes.lista',
              released: true,
              selected: false,
            },
            {
              name: 'Inserir',
              value: 'fabricantes.inserir',
              released: true,
              selected: false,
            },
          ],
        },
        //Botao Produtos
        {
          selected: false,
          name: 'Produtos',
          released: true,
          actions: [
            {
              name: 'Listar',
              value: 'produtos.lista',
              released: true,
              selected: false,
            },
            {
              name: 'Inserir',
              value: 'produtos.inserir',
              released: true,
              selected: false,
            },
            {
              name: 'Exportar Produtos',
              value: 'produtos.export',
              released: true,
              selected: false,
            },
            {
              name: 'Associar Produtos Tray',
              value: 'produtos.import',
              released: true,
              selected: false,
            },
          ],
        },
        //Botao Clientes
        {
          selected: false,
          name: 'Clientes',
          released: false,
          actions: [
            {
              name: 'Endereços [ID]',
              value: 'clientes.enderecos',
              released: true,
              selected: false,
            },
          ],
        },
        //Botao Pedidos
        {
          selected: false,
          name: 'Pedidos',
          released: true,
          actions: [
            {
              name: 'Lista',
              value: 'pedidos.lista',
              released: true,
              selected: false,
            },
            {
              name: 'Importar [off-line]',
              value: 'pedidos.inserir',
              released: true,
              selected: false,
            },
          ],
        },
      ],
      integrationName: 'TRAY',
      integrationTypeList: ['Pedidos', 'Produtos'],
      integrationType: 'Pedidos',
      orderHeader: [{ text: 'Aviso', value: 'warnings' }],
      itemHeader: [{ text: 'Aviso', value: 'warnings' }],
      orderData: [],
      itemData: [],
      worksheet: {},
      worksheetJson: {},
      dialogs: {
        showCategoryDialog: false,
        showIntegrationEditCategoryDialog: false,
        categoryObject: {},
        showMessageDialog: false,
        messages: [],
        showSelectBasic: false,
        showProductDialog: false,
        showExportProductDialog: false,
        productObject: {},
        showImageDialog: false,
        hasImages: false,
        imagesList: [],
        showSelectCategory: false,
        showSelectManufacturer: false,
        showOrderDataDialog: false,
        orderData: {},
        showIntegrationProductDialog: false,
        showIntegrationEditProductDialog: false,
        objectProduct: {},
        showIntegrationManufacturerDialog: false,
        showIntegrationEditManufacturerDialog: false,
        objectManufacturer: {},
        showIntegrationCategoryDialog: false,
        objectCategory: {},
        showIntegrationDataDialog: false,
        objectIntegration: {},
        showSelectBrand: false,
        showSynchronizationLogDialog: false,
        messageArray: [],
        showDialogAssociateProducts: false,
      },
      dialogBindColumns: false,
      bindedColumnsList: null,
      associateProductsList: null,
      showIntegrationDataDialog: false,
      overlay: {
        overlay: false,
        cycle: false,
        absolute: false,
        color: 'dark',
        model: 0,
        especificacoes: '',
        item: {},
      },

      search: '',
    }
  },
  methods: {
    ...mapActions({
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
      integrateOrders: 'trayModule/integrateOrders',
      getManufacturersIntegration: 'trayModule/getManufacturersIntegration',
      getCategoriesIntegration: 'trayModule/getCategoriesIntegration',
      getProductsIntegration: 'trayModule/getProductsIntegration',
      removeCategory: 'trayModule/removeCategory',
      removeManufacturer: 'trayModule/removeManufacturer',
      removeProduct: 'trayModule/removeProduct',
      getProductIntegration: 'trayModule/getProductIntegration',
      getOrdersIntegration: 'trayModule/getOrdersIntegration',
    }),

    filterOnTable(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value
          .toString()
          .toLocaleUpperCase()
          .indexOf(search.toLocaleUpperCase()) !== -1
      )
    },

    async validateOrders() {
      try {
        this.setLoadingDialogMessage(
          `Validando Registros [${this.selectedTable}]`
        )
        this.showLoadingDialog(true)

        if (this.orderData.length <= 0) return

        const filters = { todos: 'S' }
        await this.getProductsIntegration(filters)

        this.orderData = await this.orderData.map((row) => {
          const warning = verifyOrderWarnings(row)
          if (warning) row.warnings.push(warning)

          this.validateOrderItemList(row.items)
          const items = this.itemData.filter((el) => row.pedido == el.pedido)
          const warnings = items.filter((item) => item.warnings.length > 0)
          if (warnings && warnings.length > 0)
            row.warnings.push(
              ` + ${warnings.length} erro(s) de produto(s) neste pedido.`
            )

          return row
        })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },

    actMsgProduto(reference) {
      const result = this.productIntegrationList.filter(
        (v) => v.IDITEMINTEGRACAO == reference
      )

      let warning = null
      if (result.length == 0) warning = `Item não encontrado [${reference}]`

      return warning
    },

    async validateOrderItemList(items) {
      if (items.length <= 0) return

      items = await items.map((row) => {
        const warning = this.actMsgProduto(row.idProduto)
        if (warning)
          row.warnings = [
            warning +
              ` Produto Gestão [${row.referencia}]
                  ${
                    row.idVariacao
                      ? 'Cód. Variação [' + row.idVariacao + ']'
                      : ''
                  }
                `,
          ]

        return row
      })
    },

    async getManufacturers() {
      await this.getManufacturersIntegration({})
      await this.clearBasicData()

      if (this.manufacturerIntegrationList.length > 0)
        this.extractData(this.manufacturerIntegrationList)

      this.dataHeader = this.manufacturerHeaders
    },

    async getProducts() {
      await this.getProductsIntegration(this.filters.product)
      await this.clearBasicData()

      if (this.productIntegrationList.length > 0)
        this.extractData(this.productIntegrationList)

      this.dataHeader = this.productHeaders
    },

    async getCategories() {
      await this.getCategoriesIntegration({})
      await this.clearBasicData()

      if (this.categoryIntegrationList.length > 0)
        this.extractData(this.categoryIntegrationList)

      this.dataHeader = this.categoryHeaders
    },
    closeOverlay() {
      this.overlay.overlay = !this.overlay.overlay
    },
    toogleOverlay(item = null) {
      const imagensName = ['IMAGEM', 'IMAGEM1', 'IMAGEM2', 'IMAGEM3']
      this.imagesList = []
      this.overlay.model = 0
      this.overlay.item = item
      if (item && item.images) {
        this.overlay.especificacoes = item.images.especificacoes
        imagensName.forEach((key) => {
          if (item.images.images_base64[key]) {
            let path = 'data:image/jpg;base64,' + item.images.images_base64[key]
            this.imagesList.push(path)
          }
        })
        this.closeOverlay()
      }
    },
    closeExportDialog() {
      this.dialogs.showExportProductDialog =
        !this.dialogs.showExportProductDialog
      this.selectedAction.selected = false
    },

    editItemTable(item, owner) {
      owner = owner.charAt(0).toUpperCase() + owner.slice(1)
      this.dialogs[`object${owner}`] = item
      this.dialogs[`showIntegrationEdit${owner}Dialog`] =
        !this.dialogs[`showIntegrationEdit${owner}Dialog`]
    },

    async removeIntegrationTable(item, owner, key = 'ID') {
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('labels.excluir'),
          this.$i18n.t('dialogs.exclusao', {
            nome: 'registro',
            codigo: item[key],
          }),
          { color: 'red' }
        )
      ) {
        try {
          var payload = {}
          var getFnc = ''
          switch (owner) {
            case 'Manufacturer':
              getFnc = 'getManufacturers'
              if (item.IDINTEGRACAO) {
                payload.manufacturerId = item.IDINTEGRACAO
                payload.type = 'integration'
              } else payload.manufacturerId = item[key]
              break

            case 'Category':
              getFnc = 'getCategories'
              if (item.IDINTEGRACAO) {
                payload.categoryId = item.IDINTEGRACAO
                payload.type = 'integration'
              } else payload.categoryId = item[key]
              break

            default:
              // product
              getFnc = 'getProducts'
              if (item.IDITEMINTEGRACAO) {
                payload.productId = item.IDITEMINTEGRACAO
                payload.type = 'integration'
              } else payload.productId = item[key]
              break
          }

          let fnc = `remove${owner}`

          let response = await this[fnc](payload)
          this.$toasted.success(response.data)

          await this[getFnc]()
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        }
      }
    },

    async removeItemIntegrationList(item, key = 'ID') {
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('labels.excluir'),
          this.$i18n.t('dialogs.exclusao', {
            nome: 'registro',
            codigo: item[key],
          }),
          { color: 'red' }
        )
      ) {
        this.dataList = this.dataList.filter((val) => {
          return val[key] !== item[key]
        })
      }
    },

    editIntegrationProducts(item, origin = null) {
      if (this.dialogs.showIntegrationProductDialog) {
        if (origin) var newObj = trayService.translateProductToFirebird(item)

        this.dataList = this.dataList.map((product) => {
          if (product.CODIGO === newObj.CODIGO) {
            product = {
              ...product,
              ...newObj,
              PRECO: newObj.PRECO ?? newObj.PRECOVAREJO, // apenas para exibição
              CATEGORIAS: newObj.categorias,
            }
          }
          return product
        })
      } else this.dialogs.objectProduct = item
      this.dialogs.showIntegrationProductDialog =
        !this.dialogs.showIntegrationProductDialog
    },

    editIntegrationCategories(item, origin = null) {
      if (this.dialogs.showIntegrationCategoryDialog) {
        if (origin) var newItem = trayService.translateCategoryToFirebird(item)
        this.dataList = this.dataList.map((category) => {
          if (category.ID === newItem.ID) {
            category = {
              ...category,
              ...newItem,
            }
          }
          return category
        })
      } else this.dialogs.objectCategory = item
      this.dialogs.showIntegrationCategoryDialog =
        !this.dialogs.showIntegrationCategoryDialog
    },
    editIntegrationManufacturer(item, origin = null) {
      if (this.dialogs.showIntegrationManufacturerDialog) {
        if (origin)
          var newItem = trayService.translateManufacturerToFirebird(item)
        this.dataList = this.dataList.map((manufacturer) => {
          if (manufacturer.FABRICANTE === newItem.FABRICANTE) {
            manufacturer = {
              ...manufacturer,
              ...newItem,
            }
          }
          return manufacturer
        })
      } else this.dialogs.objectManufacturer = item
      this.dialogs.showIntegrationManufacturerDialog =
        !this.dialogs.showIntegrationManufacturerDialog
    },

    clearSelectionsAndLists() {
      this.tablesButtons.forEach((button) => {
        this.unselectButton(button)
      })
      this.selectedTable = ''
    },

    unselectButton(buttonReference) {
      buttonReference.selected = false
    },

    performFilters(event) {
      this.filters = JSON.parse(JSON.stringify(event.filters))
      this.filters.todos = 'S'
      this.selectTableActions(event.action)
    },

    extractData(dataList) {
      if (Array.isArray(dataList)) {
        if (dataList.length > 0) {
          Object.keys(dataList[0]).forEach((dataHeader) => {
            if (!this.excludedHeaders.find((header) => header == dataHeader))
              this.dataHeader.push({
                text: dataHeader,
                value: dataHeader,
                width: dataHeader.indexOf('DESCRICAO') != -1 ? 200 : null,
                class: 'backgroundColor: light-blue darken-4',
              })
          })
          this.dataList = dataList
        } else throw `Não foram encontrados dados [${this.selectedIsetTable}]`
      } else {
        let dataArray = Object.keys(dataList)
        Object.keys(dataList[dataArray[0]]).forEach((dataHeader) => {
          this.dataHeader.push({ text: dataHeader, value: dataHeader })
        })
        Object.keys(dataList).forEach((data) => {
          this.dataList.push({
            ...dataList[data],
          })
        })
      }
    },

    mountProductDataList(product) {
      return {
        CODIGO: product.CODIGO,
        DESCRICAO: product.DESCRICAO,
        PRECO:
          product.item_integracao && product.item_integracao.PRECO > 0
            ? product.item_integracao.PRECO
            : product.PRECOITEM[
                this.system[`CIFRAO${this.system.MOEDAPRINCIPAL}`]
              ],
        PRECOVAREJO:
          product.PRECOITEM[this.system[`CIFRAO${this.system.MOEDAPRINCIPAL}`]],
        IDITEMINTEGRACAO: product.item_integracao
          ? product.item_integracao.IDITEMINTEGRACAO
          : null,
        QUANTIDADEMAXCOMPRA: product.item_integracao
          ? product.item_integracao.QUANTIDADEMAXCOMPRA
          : 0,
        QUANTIDADEMINCOMPRA: product.item_integracao
          ? product.item_integracao.QUANTIDADEMINCOMPRA
          : 0,
        QUANTIDADECRITICA: product.item_integracao
          ? product.item_integracao.QUANTIDADECRITICA
          : 0,
        DIASPARAMANIPULACAO: product.item_integracao
          ? product.item_integracao.DIASPARAMANIPULACAO
          : 0,
        ISFRETEGRATIS: product.item_integracao
          ? product.item_integracao.ISFRETEGRATIS === 'S'
          : 'N',
        ISPRODUTOSUPEROFERTA: product.item_integracao
          ? product.item_integracao.ISPRODUTOSUPEROFERTA === 'S'
          : 'N',
        ISPRODUTOLANCAMENTO: product.item_integracao
          ? product.item_integracao.ISPRODUTOLANCAMENTO === 'S'
          : 'N',
        ISPRODUTODESTAQUE: product.item_integracao
          ? product.item_integracao.ISPRODUTODESTAQUE === 'S'
          : 'N',
        ISPRODUTOEXCLUSIVO: product.item_integracao
          ? product.item_integracao.ISPRODUTOEXCLUSIVO === 'S'
          : 'N',
        ISEMBALARPRESENTE: product.item_integracao
          ? product.item_integracao.ISEMBALARPRESENTE === 'S'
          : 'N',
        ISPERMITIRCOMPRA: product.item_integracao
          ? product.item_integracao.ISPERMITIRCOMPRA === 'N'
          : 'S',
        FABRICANTE_INTEGRACAO:
          product.item_integracao &&
          product.item_integracao.FABRICANTE_INTEGRACAO
            ? product.item_integracao.FABRICANTE_INTEGRACAO
            : '',
        CATEGORIAS: product.item_integracao
          ? product.item_integracao.categorias
          : [],
        VENDAINTERNET: product.item_integracao
          ? product.item_integracao.VENDAINTERNET
          : 'N',
        INTEGRACAO: product.item_integracao
          ? product.item_integracao.INTEGRACAO
          : null,
      }
    },

    async showSelectedProducts(e) {
      if (e.length > 0) {
        let selectedProductList = []

        e.forEach((product) => {
          selectedProductList.push(this.mountProductDataList(product))
        })
        this.showInsertButton = true
        this.dialogs.showSelectBasic = false
        this.clearBasicData()
        this.extractData(selectedProductList)
        this.dataHeader = this.productHeadersToIntegrate
        this.dialogs.messageArray = []
        this.dialogs.messageArray.push(
          'Confira na tabela os itens selecionados',
          "Se estiverem corretos clique em 'Enviar' "
        )
        this.dialogs.showMessageDialog = true
      } else {
        this.$toasted.success('Nenhum item foi selecionado.')
      }
    },

    showCategories(data) {
      this.clearBasicData()
      this.extractData(data.subCategories)
    },
    showSelectedCategories(e) {
      if (e.length > 0) {
        this.dialogs.showSelectCategory = false
        this.clearBasicData()
        this.extractData(e)
        this.dataHeader = this.categoryHeadersToIntegrate
      }
    },
    showSelectedManufacturers(e) {
      if (e.length > 0) {
        if (this.integrationData.DE_PARA?.includes('FABRICANTES|MARCAS'))
          this.dialogs.showSelectBrand = false
        else this.dialogs.showSelectManufacturer = false

        this.clearBasicData()
        this.extractData(this.convertManufacturerObject(e))
        this.dataHeader.push({
          text: 'Ações',
          value: 'editarFabricantesIntegracao',
          width: '100',
          class: 'backgroundColor: light-blue darken-4',
        })
      }
    },
    convertManufacturerObject(e) {
      let newList = []
      e.forEach((manufacturer) => {
        newList.push({
          FABRICANTE: manufacturer.NOME,
        })
      })
      return newList
    },
    convertCategoriesObject(e) {
      let newList = []

      e.forEach((category) => {
        newList.push({
          ID: category.ID,
          NOME: category.NOME,
          PARENT_ID: category.PARENT_ID ?? null,
          SUBTITULO: category.SUBTITULO,
        })
      })
      return newList
    },

    sendValidation() {
      if (!this.dataList || this.dataList.length == 0)
        throw `Não foi selecionado ${this.selectedTable}`
    },

    convertProductObject(dataList) {
      let newDataList = []

      dataList.forEach((product) => {
        if (
          ((!product.PRECOINTEGRACAO || product.PRECOINTEGRACAO === 0) &&
            product.PRECO == product.PRECOVAREJO) ||
          (product.PRECOINTEGRACAO > 0 && product.PRECO == 0)
        )
          product.PRECO = null
        newDataList.push({
          ...product,
          VENDAINTERNET: 'S',
          categories:
            product.CATEGORIAS.length > 0
              ? product.CATEGORIAS.map((category) => {
                  return category.ID
                })
              : null,
          ISFRETEGRATIS: product.ISFRETEGRATIS ?? 'N',
          ISPRODUTOSUPEROFERTA: product.ISPRODUTOSUPEROFERTA ?? 'N',
          ISPRODUTOLANCAMENTO: product.ISPRODUTOLANCAMENTO ?? 'N',
          ISPRODUTODESTAQUE: product.ISPRODUTODESTAQUE ?? 'N',
          ISPRODUTOEXCLUSIVO: product.ISPRODUTOEXCLUSIVO ?? 'N',
          ISEMBALARPRESENTE: product.ISEMBALARPRESENTE ?? 'N',
          ISPERMITIRCOMPRA: product.ISPERMITIRCOMPRA ?? 'N',
        })
      })

      return { items: newDataList }
    },
    async sendCategory(value) {
      try {
        this.setLoadingDialogMessage(
          `Inserindo Registros [${this.selectedTable}]`
        )
        this.showLoadingDialog(true)
        const payload = {
          categories: [trayService.translateCategoryToFirebird(value)],
        }

        const { data } = await trayService.integrateCategories(payload)

        if (data.error) throw data.error
        else {
          await this.$refs.confirmDialogErrors.open(
            `Exito ao integrar ${this.selectedTable}`,
            data.OK,
            {
              color: 'success',
              width: 500,
            }
          )

          this.dialogs.showIntegrationEditCategoryDialog =
            !this.dialogs.showIntegrationEditCategoryDialog

          await this.getCategories()
        }
      } catch (error) {
        await this.$refs.confirmDialogErrors.open(
          `Erro ao integrar ${this.selectedTable}`,
          [error],
          {
            color: 'error darken-3',
            width: 500,
          }
        )
      } finally {
        this.showLoadingDialog(false)
      }
    },

    async sendManufacturer(value) {
      try {
        this.setLoadingDialogMessage(
          `Inserindo Registros [${this.selectedTable}]`
        )
        this.showLoadingDialog(true)
        const payload = {
          manufacturers: [trayService.translateManufacturerToFirebird(value)],
        }

        const { data } = await trayService.integrateManufacturers(payload)

        if (data.error) throw data.error
        else {
          await this.$refs.confirmDialogErrors.open(
            `Exito ao integrar ${this.selectedTable}`,
            data.OK,
            {
              color: 'success',
              width: 500,
            }
          )

          this.dialogs.showIntegrationEditManufacturerDialog =
            !this.dialogs.showIntegrationEditManufacturerDialog

          await this.getManufacturers({})
        }
      } catch (error) {
        await this.$refs.confirmDialogErrors.open(
          `Erro ao integrar ${this.selectedTable}`,
          [error],
          {
            color: 'error darken-3',
            width: 500,
          }
        )
      } finally {
        this.showLoadingDialog(false)
      }
    },

    async sendProduct(item) {
      try {
        this.setLoadingDialogMessage(
          `Inserindo Registros [${this.selectedTable}]`
        )
        this.showLoadingDialog(true)
        const payload = {
          items: [trayService.translateProductToFirebird(item)],
        }
        const { data } = await trayService.integrateProducts(payload)

        if (data.error) throw data.error
        else {
          await this.$refs.confirmDialogErrors.open(
            `Exito ao integrar ${this.selectedTable}`,
            data.OK,
            {
              color: 'success',
              width: 500,
            }
          )

          this.dialogs.showIntegrationEditProductDialog =
            !this.dialogs.showIntegrationEditProductDialog

          await this.getProducts()
        }
      } catch (error) {
        await this.$refs.confirmDialogErrors.open(
          `Erro ao integrar ${this.selectedTable}`,
          [error],
          {
            color: 'error darken-3',
            width: 500,
          }
        )
      } finally {
        this.showLoadingDialog(false)
      }
    },
    async sendProducts() {
      try {
        this.sendValidation()
        this.setLoadingDialogMessage(
          `Inserindo Registros [${this.selectedTable}]`
        )
        this.showLoadingDialog(true)
        const payload = this.convertProductObject(this.dataList)

        const { data } = await trayService.integrateProducts(payload)

        if (data.error) throw data.error
        else
          await this.$refs.confirmDialogErrors.open(
            `Exito ao integrar ${this.selectedTable}`,
            data.OK,
            {
              color: 'success',
              width: 500,
            }
          )
      } catch (error) {
        await this.$refs.confirmDialogErrors.open(
          `Erro ao integrar ${this.selectedTable}`,
          [error],
          {
            color: 'error darken-3',
            width: 500,
          }
        )
      } finally {
        this.showLoadingDialog(false)
      }
    },

    async sendCategories() {
      try {
        if (this.dataList.length <= 0)
          throw `Não foi selecionado ${this.selectedTable}`

        this.setLoadingDialogMessage(
          `Inserindo Registros [${this.selectedTable}]`
        )
        this.showLoadingDialog(true)
        let categoriesObject = {
          categories: this.convertCategoriesObject(this.dataList),
        }
        const { data } = await trayService.integrateCategories(categoriesObject)
        if (data.error) throw data.error
        else
          await this.$refs.confirmDialogErrors.open(
            `Exito ao integrar ${this.selectedTable}`,
            data.OK,
            {
              color: 'success',
              width: 500,
            }
          )
      } catch (error) {
        await this.$refs.confirmDialogErrors.open(
          `Erro ao integrar ${this.selectedTable}`,
          [error],
          {
            color: 'error darken-3',
            width: 500,
          }
        )
      } finally {
        this.showLoadingDialog(false)
      }
    },

    async sendManufacturers() {
      try {
        if (this.dataList.length <= 0) throw `Nenhum fabricante selecionado`

        this.setLoadingDialogMessage(
          `Inserindo Registros [${this.selectedTable}]`
        )
        this.showLoadingDialog(true)
        let manufacturersObject = {
          manufacturers: this.dataList,
        }
        const { data } = await trayService.integrateManufacturers(
          manufacturersObject
        )
        if (data.error) throw data.error
        else
          await this.$refs.confirmDialogErrors.open(
            `Exito ao integrar ${this.selectedTable}`,
            data.OK,
            {
              color: 'success',
              width: 500,
            }
          )
      } catch (error) {
        await this.$refs.confirmDialogErrors.open(
          `Erro ao integrar ${this.selectedTable}`,
          [error],
          {
            color: 'error darken-3',
            width: 500,
          }
        )
      } finally {
        this.showLoadingDialog(false)
      }
    },

    unShowingDialogs() {
      this.dialogs.showSelectCategory = false
      this.dialogs.showSelectBasic = false
      this.dialogs.showExportProductDialog = false
      this.dialogs.showSelectBrand = false
      this.dialogs.showSelectManufacturer = false
      this.dialogs.showOrderDataDialog = false
      this.dialogs.showDialogAssociateProducts = false
    },
    async selectTableActions(selectedAction) {
      // try {

      this.selectedTableActions.forEach((action) => {
        action.selected = action.value == selectedAction.value
      })
      await this.$nextTick()

      if (this.selectedTable == 'Categorias') {
        if (selectedAction.value == 'categorias.inserir')
          this.dialogs.showSelectCategory = true
        else {
          try {
            this.setLoadingDialogMessage('Carregando Categorias')
            this.showLoadingDialog(true)
            this.getCategories()
          } catch (error) {
            this.$toasted.error(error, { duration: null })
          } finally {
            this.showLoadingDialog(false)
          }
        }
      } else if (this.selectedTable == 'Produtos') {
        if (selectedAction.value == 'produtos.lista') {
          try {
            this.setLoadingDialogMessage('Carregando Produtos')
            this.showLoadingDialog(true)
            // componente ira fazer paginacao
            this.filters.product.todos = 'S'
            await this.getProducts()
          } catch (error) {
            this.$toasted.error(error, { duration: null })
          } finally {
            this.showLoadingDialog(false)
          }
        } else if (selectedAction.value == 'produtos.inserir') {
          this.dialogs.showSelectBasic = true
        } else if (selectedAction.value == 'produtos.export') {
          this.dialogs.showExportProductDialog = true
        } else if (selectedAction.value == 'produtos.import') {
          this.dialogs.showDialogAssociateProducts = true
        }
      } else if (this.selectedTable == 'Fabricantes') {
        if (selectedAction.value == 'fabricantes.lista') {
          try {
            this.setLoadingDialogMessage('Carregando Fabricantes')
            this.showLoadingDialog(true)
            await this.getManufacturers()
          } catch (error) {
            this.$toasted.error(error)
          } finally {
            this.showLoadingDialog(false)
          }
        } else if (selectedAction.value == 'fabricantes.inserir') {
          if (this.integrationData.DE_PARA?.includes('FABRICANTES|MARCAS')) {
            this.dialogs.showSelectBrand = true
          } else this.dialogs.showSelectManufacturer = true
        } else {
          this.$toasted.info('Esta ação está sendo implementada')
        }
      } else if (this.selectedTable == 'Pedidos') {
        if (selectedAction.value == 'pedidos.inserir')
          this.dialogs.showOrderDataDialog = true
        else {
          try {
            this.setLoadingDialogMessage('Carregando...')
            this.showLoadingDialog(true)
            this.dialogs.showOrderDataDialog = false
            this.orderData = []
            if (!this.filters.dataini && !this.filters.datafim) {
              this.filters.dataini = this.getDate('I')
              this.filters.datafim = this.getDate('F')
            }
            await this.getOrdersIntegration(this.filters)

            const header = [
              'DATA',
              'HORA',
              { text: 'S', value: 'SERIE' },
              { text: 'Nº TRAY', value: 'NUMEROEXPORTADO' },
              'NUMERO',
              { text: 'CLIENTE', value: 'NOME_EMPRESA' },
              'VALOR',
              { text: '% DESC.', value: 'PERCENTUALDESCONTO' },
              'TIPO',
              { text: 'PRÉ', value: 'PRELIBERADO' },
              { text: 'L', value: 'LIBERADO' },
              { text: 'T', value: 'TIPOLIBERACAO' },
              { text: 'P', value: 'TIPOPRECO' },
              { text: 'F', value: 'FILIAL' },
              { text: 'VENDEDOR', value: 'NOMEVENDEDOR' },
            ]
            this.dataHeader = []
            header.forEach((ele) => {
              this.dataHeader.push({
                text: ele.text ?? ele,
                value: ele.value ?? ele,
              })
            })

            this.dataList = []
            if (
              this.orderIntegrationList ||
              this.orderIntegrationList.length > 0
            ) {
              Object.keys(this.orderIntegrationList).forEach((data) => {
                const inf = this.orderIntegrationList[data]
                const obj = {
                  DATA: converterDataDB(inf.DATA),
                  HORA: inf.HORA,
                  SERIE: inf.SERIE,
                  NUMEROEXPORTADO: inf.NUMEROEXPORTADO,
                  NUMERO: inf.NUMERO,
                  VALOR: this.formatCurrency(inf.MOEDA, inf.VALOR),
                  PERCENTUALDESCONTO: this.formatDecimal(
                    inf.PERCENTUALDESCONTO,
                    2,
                    2
                  ),
                  NOME_EMPRESA: inf.NOME_EMPRESA,
                  TIPO: inf.TIPO,
                  PRELIBERADO: inf.PRELIBERADO,
                  LIBERADO: inf.LIBERADO,
                  TIPOLIBERACAO: inf.TIPOLIBERACAO,
                  TIPOPRECO: inf.TIPOPRECO,
                  FILIAL: inf.FILIAL,
                  NOMEVENDEDOR: inf.NOMEVENDEDOR,
                }
                this.dataList.push(obj)
              })
            }
          } catch (error) {
            this.$toasted.error(error)
          } finally {
            this.showLoadingDialog(false)
          }
        }
      }

      this.selectedAction = selectedAction
    },
    getDate(type = 'I') {
      const date1 = new Date().setDate(
        new Date().getDate() - (type == 'I' ? 30 : 0)
      )
      const date = new Date(date1)
      let day = this.f(date.getDate())
      let month = this.f(date.getMonth() + 1)
      let year = date.getFullYear()
      const fullDate = year + '-' + month + '-' + day

      return fullDate
    },
    f(n) {
      return n > 9 ? n : '0' + n
    },
    async selectTable(button) {
      await this.clearBasicData()
      this.selectedTable = button.name
      this.selectedTableActions = JSON.parse(JSON.stringify(button.actions))
      this.tablesButtons.forEach((val) => {
        val.selected = val.name == button.name
      })
    },
    clearBasicData() {
      this.dataHeader = []
      this.dataList = []
      this.orderData = []
      this.unShowingDialogs()
    },
    async verifyIntegrationStatus(integration = null) {
      if (this.integrationData?.DATACADASTRO?.length > 0) {
        this.disableForm = true
        this.showFieldId = false
        this.showInsertButton = false
        this.integrationData = { ...this.freshIntegration }
        this.selectedTable = ''
        this.selectedTableActions = []
        this.selectedAction = null
        this.clearBasicData()
      } else this.getIntegration(integration)
    },
    async getIntegration(integration = null) {
      try {
        if (integration != null) {
          this.setLoadingDialogMessage('Carregando Dados da Integração')
          this.showLoadingDialog(true)
          let response = await service.getIntegrationData(
            integration.NOME_EMPRESA
          )
          if (response) {
            this.integrationData = {
              ...response,
              COLUNAS_EXPORTACAO: JSON.parse(response.COLUNAS_EXPORTACAO),
            }
          } else {
            Object.keys(this.integrationData).forEach((key) => {
              this.integrationData[key] = null
            })
            this.$toasted.info('Não foram encontrados dados')
          }
        } else {
          throw `Nenhuma integração selecionada.`
        }
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.showLoadingDialog(false)
      }
    },
    openIntegrationDataDialog(integration = null) {
      if (integration && integration.NOME_EMPRESA) {
        this.dialogs.objectIntegration = integration
      } else {
        this.dialogs.objectIntegration = {
          ...this.integrationData,
          NOME_EMPRESA: this.integrationName,
        }
      }
      this.showIntegrationDataDialog = !this.showIntegrationDataDialog
    },
    closeIntegrationDataDialog() {
      this.showIntegrationDataDialog = !this.showIntegrationDataDialog
      this.getIntegrations(this.integrationName)
    },

    async associateProductsIntegration(value) {
      try {
        this.setLoadingDialogMessage('Atualizando Integração')
        this.showLoadingDialog(true)

        const payload = { items: value }
        const { data } = await trayService.integrateProducts(payload)

        if (data.error)
          await this.$refs.confirmDialogErrors.open(
            `Erro ao integrar ${this.selectedTable}`,
            data.error,
            {
              color: 'error darken-3',
              width: 500,
            }
          )

        if (data.OK)
          await this.$refs.confirmDialogErrors.open(
            `Exito ao integrar ${this.selectedTable}`,
            data.OK,
            {
              color: 'success',
              width: 500,
            }
          )
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    async setBindedColumnsList(value) {
      try {
        this.setLoadingDialogMessage('Atualizando Integração')
        this.showLoadingDialog(true)

        if (this.integrationData) {
          this.integrationData.COLUNAS_EXPORTACAO = value

          const response = await service.updateIntegration(this.integrationData)
          this.$toasted.success(response.status)
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    setWorksheet(workbook) {
      const first_sheet_name = workbook.SheetNames[0]
      this.worksheet = workbook.Sheets[first_sheet_name]
      this.worksheetJson = XLSX.utils.sheet_to_json(this.worksheet)
    },

    getDataRanges() {
      let dataRanges = {
        firstIndexOrder: 0,
        firstIndexItem: 0,
        firstIndexTotalizer: 0,
      }
      this.worksheetJson.forEach((row, index) => {
        Object.keys(row).forEach((key) => {
          if (row[key] === 'DATA_PEDIDOS') {
            dataRanges.firstIndexOrder = index
          } else if (row[key] === 'ID_PRODUTO') {
            dataRanges.firstIndexItem = index
          } else if (row[key] === 'Totalizadores') {
            dataRanges.firstIndexTotalizer = index
          }
        })
      })
      return dataRanges
    },

    extractItemData(row, type) {
      if (type === 'header')
        Object.keys(row).forEach((key) => {
          this.itemHeader.push({
            text: row[key],
            value: key,
          })
        })
      else if (type === 'body') {
        let item = {}
        Object.keys(row).forEach((data) => {
          item[data] = row[data]
        })
        this.itemData.push(item)
      }
    },
    extractOrderData(row, type) {
      if (type === 'header')
        Object.keys(row).forEach((key) => {
          this.orderHeader.push({
            text: row[key],
            value: key,
          })
        })
      else if (type === 'body') {
        let order = {}
        Object.keys(row).forEach((data) => {
          order[data] = row[data]
        })
        this.orderData.push(order)
      }
    },
    manageFile() {
      let dataRanges = this.getDataRanges()

      this.worksheetJson.forEach((row, index) => {
        if (index === dataRanges.firstIndexOrder)
          this.extractOrderData(row, 'header')
        else if (index === dataRanges.firstIndexItem)
          this.extractItemData(row, 'header')
        else if (
          index > dataRanges.firstIndexOrder &&
          index < dataRanges.firstIndexItem - 1
        ) {
          this.extractOrderData(row, 'body')
        } else if (
          index > dataRanges.firstIndexItem &&
          index < dataRanges.firstIndexTotalizer
        )
          this.extractItemData(row, 'body')
      })

      if (this.orderData.length > 0) {
        this.orderData = convertOrdersList(this.orderData)
      }

      if (this.orderHeader.length > 0) convertOrdersHeader(this.orderHeader)

      if (this.itemData.length > 0)
        this.itemData = convertItemsList(this.itemData)

      if (this.itemHeader.length > 0) convertItemsHeader(this.itemHeader)

      const list = this.orderData.map((el) => {
        if (
          this.statusList.find((row) => row.descricao == el.status) == undefined
        )
          this.statusList.push({ DESCRICAO: el.status })

        const items = this.itemData.filter((row) => row.pedido == el.pedido)
        el.items = items

        return el
      })

      this.orderData = list
    },

    manageProductsFile() {
      let dataRanges = this.getProductsDataRanges()

      this.worksheetJson.forEach((row, index) => {
        if (index === dataRanges.indexProducts)
          this.extractOrderData(row, 'header')
        else if (index === dataRanges.indexVariations)
          this.extractItemData(row, 'header')
      })
    },
    async runIntegration() {
      try {
        if (this.integrationData && this.integrationData.ATIVO == 'S')
          this.setLoadingDialogMessage('Parando serviço')
        else if (this.integrationData && this.integrationData.ATIVO == 'N')
          this.setLoadingDialogMessage('Iniciando Serviço')

        this.showLoadingDialog(true)

        let response = ''

        let integrationData = { ...this.integrationData }

        if (this.integrationData && this.integrationData.ATIVO == 'S') {
          integrationData.ATIVO = 'N'
          this.disableForm = false
        } else if (this.integrationData && this.integrationData.ATIVO == 'N') {
          integrationData.ATIVO = 'S'
        }

        response = await service.updateIntegration(integrationData)
        this.integrationData.ATIVO = integrationData.ATIVO

        if (this.integrationData.ATIVO == 'N') this.clearSelectionsAndLists()

        this.$toasted.success(response.status)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    async changeFileOrder(file) {
      this.cleanData()
      if (file) {
        this.setLoadingDialogMessage('Carregando Documento')
        this.showLoadingDialog(true)
        const fileExtension = file.name.split('.')[1]
        if (fileExtension == 'xls') {
          const data = await file.arrayBuffer()
          const workbook = XLSX.read(data)
          await this.setWorksheet(workbook)
          await this.manageFile()
        } else {
          this.$toasted.info(`Arquivo [*.${fileExtension}] não suportado.`)
        }
        this.showLoadingDialog(false)
      }
    },
    async prepareToSend(form) {
      if (this.orderSpecs.warnings > 0) {
        this.$toasted.error('Verifique os avisos dos pedidos primeiro', {
          duration: null,
        })
        return
      }

      if (this.orderData.length > 0 && this.itemData.length > 0) {
        try {
          this.setLoadingDialogMessage('Enviando os dados para o Gestão.')
          this.showLoadingDialog(true)
          const orderList = []
          this.orderData.forEach((row) => {
            let order = prepareOrderObject(row)
            orderList.push(order)
          })
          orderList.push(form)
          await this.integrateOrders(orderList)
          const messages = []
          if (this.integrateErrors.length > 0)
            this.integrateErrors.forEach((error) => {
              messages.push(`[ERROR] ${error}`)
            })
          if (this.integrateInfos.length > 0)
            this.integrateInfos.forEach((info) => {
              messages.push(`[INFO] ${info}`)
            })
          this.dialogs.messageArray = messages
          this.dialogs.showMessageDialog = true
          // this.cleanData()
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        } finally {
          this.showLoadingDialog(false)
        }
      } else {
        this.$toasted.info(`Planilha não informada.`)
      }
    },
    cleanData() {
      this.orderHeader = [{ text: 'Avisos', value: 'warnings' }]
      this.orderData = []
      this.itemHeader = [{ text: 'Avisos', value: 'warnings' }]
      this.itemData = []
    },
    estilizaLinha(item) {
      if (item.warnings.length > 0) return 'orange--text'
      else return 'white--text'
    },
    showWarnings(warnings) {
      this.dialogs.messageArray = []
      if (warnings.length > 0) {
        warnings.forEach((warning) => {
          if (warning.field)
            this.dialogs.messageArray.push(
              `Campo [${warning.field.toUpperCase()}] ultrapassou o tamanho máximo do gestão ${
                warning.text
              }`
            )
          else this.dialogs.messageArray.push(warning)
        })
        this.dialogs.showMessageDialog = true
      } else this.$toasted.info('Não possui avisos.')
    },

    async fetch() {
      try {
        await this.getIntegrations(this.integrationName)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  mounted() {
    this.fetch()
  },
}
</script>

<style scoped>
.headerClass {
  color: grey;
}
</style>
